import React, { useState } from "react";
import "./RoleCard.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getAbbreviation } from "../../utils/_helpers";
import { useSelector } from "react-redux";

const RoleCard = ({ role, handleEditRole }) => {
  const [editLoading, setEditLoading] = useState(false);
  const navigate = useNavigate();

  const handlePermissionClick = () => {
    navigate("/permissions", { state: { role: role } });
  };

  const handleEditClick = (role) => {
    setEditLoading(true);
    setTimeout(() => {
      handleEditRole(role);
      setEditLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 400);
  };

  const user = useSelector((state) => state.auth.user);
  const userPermissions = user?.permissions?.manage_role || [];
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);
  const canDeleteRole = hasPermission(userPermissions, "delete");
  const canWriteRole = hasPermission(userPermissions, "write");
  const canAssignRole = canWriteRole;
  // check perminssion

  return (
    <div className="col-sm-6 col-lg-3 mb-4">
      <div className="card card-md h-100">
        <div
          className="ribbon ribbon-top ribbon-bookmark"
          style={{ backgroundColor: role?.color }}
        >
          {getAbbreviation(role?.name)}
        </div>

        <div className="card-body pb-5">
          <h4 className="card_heading">{role?.name}</h4>
          <p className="mb-0">
            <b>Dept. Head:</b>{" "}
            {role.department_heads && role.department_heads.length > 0
              ? role.department_heads
                  .map((head) => `${head.first_name} ${head.last_name}`)
                  .join(", ")
              : "No head assigned"}
          </p>
          <p>
            <b>Dept. Email:</b> {role.department_email ? role.department_email : "N/A"}
          </p>
          <div className="my-3">
            <p>{role?.description}</p>{" "}
          </div>

          {canWriteRole && (
            <div className="d-flex gap-2 button_group pt-0">
              <Button
                className="flex-1"
                style={{ backgroundColor: role?.color }}
                onClick={() => handleEditClick(role)}
              >
                {editLoading ? "Loading..." : "Role Edit"}
              </Button>
              <Button
                className="flex-1"
                variant="outline-secondary"
                onClick={handlePermissionClick}
              >
                Permission
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleCard;
